import { SIDENAV_WIDTH, SIDENAV_GAP } from "app/navigation/Sidenav/constants";
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React base styles
import colors from "assets/theme-dark/base/colors";
import borders from "assets/theme-dark/base/borders";

// Material Dashboard 2 React helper functions
import pxToRem from "assets/theme-dark/functions/pxToRem";

const { background } = colors;
const { borderRadius } = borders;

const sidenav = {
  styleOverrides: {
    root: {
      width: pxToRem(SIDENAV_WIDTH),
      whiteSpace: "nowrap",
      border: "none",
    },

    paper: {
      width: pxToRem(SIDENAV_WIDTH),
      backgroundColor: background.sidenav,
      height: `calc(100vh - ${pxToRem(SIDENAV_GAP * 2)})`,
      margin: pxToRem(SIDENAV_GAP),
      borderRadius: borderRadius.xl,
      border: "none",
    },

    paperAnchorDockedLeft: {
      borderRight: "none",
    },
  },
};

export default sidenav;
